import * as L from 'leaflet';
import { AnchorLocation } from './anchorLocation.enum';
import { AnchorLocations } from './anchorLocations';

export abstract class Marker extends L.DivIcon {
  protected wrapperCssClass = '';

  protected widthPx = 0;
  protected heightPx = 0;

  protected iconAnchor = AnchorLocation.CENTER;
  protected popupAnchor = AnchorLocation.CENTER;
  protected tooltipAnchor = AnchorLocation.CENTER;

  constructor() {
    super({
      // iconUrl: 'my-icon.png',
      // iconSize: [30, markerHeightPx],
      // iconAnchor: [30, markerHeightPx],
      // popupAnchor: [0, -markerSizePx],
      // shadowUrl: 'marker_shadow.png',
      // shadowSize: [68, 95],
      // shadowAnchor: [0, -markerHeightPx],
    });
  }

  public setWrapperClass(cssClass: string): this {
    this.wrapperCssClass = cssClass;
    return this;
  }

  public setIconSize(width: number, height: number): this {
    this.widthPx = width;
    this.heightPx = height;
    return this;
  }

  public setIconAnchor(iconAnchor: AnchorLocation): this {
    this.iconAnchor = iconAnchor;
    return this;
  }

  public setTooltipAnchor(tooltipAnchor: AnchorLocation): this {
    this.tooltipAnchor = tooltipAnchor;
    return this;
  }

  public setPopupAnchor(popupAnchor: AnchorLocation): this {
    this.popupAnchor = popupAnchor;
    return this;
  }

  public processAnchorLocation(
    fullValue: number,
    thisLocation: AnchorLocation,
    halfValueLocations: Array<AnchorLocation>,
    fullValueLocations: Array<AnchorLocation>,
  ): number {
    let value = 0;
    if (halfValueLocations.includes(thisLocation)) {
      value = fullValue / 2;
    } else if (fullValueLocations.includes(thisLocation)) {
      value = fullValue;
    }
    return value;
  }

  public getMarker(latlng: L.LatLng): L.Marker {
    return L.marker(latlng, { icon: this } as L.MarkerOptions);
  }

  // overrides L.DivIcon func
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public createIcon(oldIcon?: HTMLElement): HTMLElement {
    this.create();
    return super.createIcon();
  }

  protected create(): void {
    const iconElement = this.getIcon();

    if (this.wrapperCssClass != null && this.wrapperCssClass !== '') {
      this.wrapperCssClass.split(' ').forEach((cssClass: string) => {
        iconElement.classList.add(cssClass);
      });
    }

    this.options.html = iconElement.outerHTML;

    this.options.iconSize = L.point(this.widthPx, this.heightPx);
    this.options.iconAnchor = this.getIconAnchorPoint();

    this.options.tooltipAnchor = this.getTooltipAnchorPoint(this.options.iconAnchor);
    this.options.popupAnchor = this.getPopupAnchorPoint(this.options.iconAnchor);
  }

  // relative to geo location point
  protected getIconAnchorPoint(): L.Point {
    return L.point(
      this.processAnchorLocation(
        this.widthPx,
        this.iconAnchor,
        AnchorLocations.getX(AnchorLocation.CENTER),
        AnchorLocations.getX(AnchorLocation.EAST),
      ),
      this.processAnchorLocation(
        this.heightPx,
        this.iconAnchor,
        AnchorLocations.getY(AnchorLocation.CENTER),
        AnchorLocations.getY(AnchorLocation.SOUTH),
      ),
    );
  }
  // relative to iconAnchor point
  protected getTooltipAnchorPoint(offset = L.point(0, 0)): L.Point {
    return L.point(
      this.processAnchorLocation(
        this.widthPx,
        this.tooltipAnchor,
        AnchorLocations.getX(AnchorLocation.CENTER),
        AnchorLocations.getX(AnchorLocation.EAST),
      ) - offset.x,
      this.processAnchorLocation(
        this.heightPx,
        this.tooltipAnchor,
        AnchorLocations.getY(AnchorLocation.CENTER),
        AnchorLocations.getY(AnchorLocation.SOUTH),
      ) - offset.y,
    );
  }
  // relative to iconAnchor point
  protected getPopupAnchorPoint(offset = L.point(0, 0)): L.Point {
    return L.point(
      this.processAnchorLocation(
        this.widthPx,
        this.popupAnchor,
        AnchorLocations.getX(AnchorLocation.CENTER),
        AnchorLocations.getX(AnchorLocation.EAST),
      ) - offset.x,
      this.processAnchorLocation(
        this.heightPx,
        this.popupAnchor,
        AnchorLocations.getY(AnchorLocation.CENTER),
        AnchorLocations.getY(AnchorLocation.SOUTH),
      ) - offset.y,
    );
  }

  public abstract getIcon(): HTMLElement;
}
